import { AssetFeed } from '../components/assets/AssetFeed';

export function PasLibraryPage() {
  return <AssetFeed variant="pas" showSearch showUpload />;
}
